import React from "react";
import { FilterTagContiner } from "./styled";
import { capitalizeFirstLetter } from "../../../utils/utils";

const FilterTag = ({ onClick, item, closIcon, background, color }) => {
  return (
    <FilterTagContiner onClick={onClick}>
      <div style={{ background: background, color: color }} className="tag">
        {capitalizeFirstLetter(item)}
        {closIcon}
      </div>
    </FilterTagContiner>
  );
};

export default FilterTag;
